import { iframeDataBridge } from '@/iframe/iframeDataBridge';
import { authenticatedFetch, getApiUrl } from '@/utils/auth/authService';
import { log } from '@/utils/core/vueLogger.js';
import { CacheManager } from '@/utils/core/cacheManager.js';

const posTypeCache = new CacheManager('VueCache', 'cache', {
	maxAge: 24 * 60 * 60 * 1000,
	memoryCacheTTL: 30 * 60 * 1000,
	logCategory: 'PosType',
	keyPrefix: () => `${iframeDataBridge.getCustomer() ?? 'unknown'}.${iframeDataBridge.getCurrentUser()?.id ?? 'unknown'}.posTypes.`,
});

export async function getPosTypes(forceRefresh = false) {
	if (!forceRefresh && !posTypeCache.getFromMemory('all')) {
		try {
			const legacyData = await iframeDataBridge.getStorageAsync('POSTYPES');
			if (legacyData) {
				log('info', 'PosType', '📦 Seeding Vue cache from legacy storage (POSTYPES)');
				await posTypeCache.put('all', legacyData);
				posTypeCache.setInMemory('all', legacyData);
				return legacyData;
			}
		} catch (legacyError) {
			log('warn', 'PosType', `⚠️ Legacy storage check failed: ${legacyError.message}`);
		}
	}

	return posTypeCache.fetchOrCache('all', fetchPosTypesFromAPI, { forceRefresh, fallback: [], backgroundRefresh: true });
}

async function fetchPosTypesFromAPI() {
	const response = await authenticatedFetch(getApiUrl('Sales/POSTypes'), { method: 'GET' }, 'tokenSales');

	if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

	const posTypes = await response.json();
	log('success', 'PosType', `✅ Fetched ${posTypes.length} POS types`);
	return posTypes;
}

export async function refreshPosTypes() {
	posTypeCache.clearMemory();
	await posTypeCache.clear();
}
